'use client';

import { c as _c } from "react/compiler-runtime";
import Portal from '@components/portal/Portal';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import SwiperCore from 'swiper';
import { FreeMode, Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import GallerySlideModalInnerMobile from '../gallery-slide-modal-inner/GallerySlideModalInnerMobile';
import 'swiper/css';
import style from './GallerySliderModalMobile.module.scss';
SwiperCore.use([FreeMode, Mousewheel]);
const GallerySliderModalMobile = t0 => {
  const $ = _c(51);
  const {
    architectureClassName,
    swiperActive,
    setSwiperActive,
    sliderArr,
    modalStatus,
    setModalStatus
  } = t0;
  const [swiper, setSwiper] = useState(null);
  const [allowTransition, setAllowTransition] = useState(false);
  let t1;
  if ($[0] !== sliderArr.length || $[1] !== swiper || $[2] !== swiperActive) {
    t1 = () => {
      swiper.slideTo(swiperActive <= sliderArr.length - 1 ? swiperActive - 1 : swiperActive);
    };
    $[0] = sliderArr.length;
    $[1] = swiper;
    $[2] = swiperActive;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handlePrev = t1;
  let t2;
  if ($[4] !== swiper || $[5] !== swiperActive) {
    t2 = () => {
      swiper.slideTo(swiperActive >= 0 ? swiperActive + 1 : swiperActive);
    };
    $[4] = swiper;
    $[5] = swiperActive;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleNext = t2;
  swiper?.on("slideChange", () => {
    setSwiperActive(swiper.activeIndex);
  });
  let t3;
  let t4;
  if ($[7] !== swiper || $[8] !== swiperActive) {
    t3 = () => {
      if (swiper && swiper.activeIndex !== swiperActive) {
        swiper.slideTo(swiperActive);
      }
    };
    t4 = [swiperActive, swiper];
    $[7] = swiper;
    $[8] = swiperActive;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  const t5 = !modalStatus;
  let t6;
  if ($[11] !== architectureClassName || $[12] !== t5) {
    t6 = cn(style.content, {
      [style.contentHidden]: t5
    }, architectureClassName ? architectureClassName : "");
    $[11] = architectureClassName;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== swiperActive) {
    t7 = instance => {
      instance.slideTo(swiperActive, 0);
      setSwiper(instance);
      requestAnimationFrame(() => setAllowTransition(true));
    };
    $[14] = swiperActive;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== allowTransition) {
    t8 = cn("gallery_swiper_modal", style.swiper, {
      [style.swiperAnimated]: allowTransition
    });
    $[16] = allowTransition;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== setModalStatus) {
    t9 = () => setModalStatus(false);
    $[18] = setModalStatus;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 1.35529L1.35547 16.9999" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="round" /><path d="M16.6444 16.6446L0.999901 0.999999" stroke="#1C1C1C" strokeWidth="2" strokeLinecap="round" /></svg>;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t9) {
    t11 = <button className={style.close} onClick={t9}>{t10}</button>;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== sliderArr) {
    t12 = sliderArr.map(_temp);
    $[23] = sliderArr;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cn("swiper-button-prev gallery_swiper__prev", style.prev);
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.876367 6.49105C0.605168 6.21985 0.605168 5.78015 0.876367 5.50895L5.29578 1.08954C5.56698 0.81834 6.00668 0.81834 6.27788 1.08954C6.54907 1.36073 6.54907 1.80043 6.27788 2.07163L2.34951 6L6.27788 9.92837C6.54907 10.1996 6.54907 10.6393 6.27788 10.9105C6.00668 11.1817 5.56698 11.1817 5.29578 10.9105L0.876367 6.49105ZM14.9443 6.69444L1.36741 6.69445L1.36741 5.30556L14.9443 5.30556L14.9443 6.69444Z" fill="#1C1C1C" /></svg>;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== handlePrev) {
    t15 = <div className={t13} onClick={handlePrev} role="button" tabIndex="0">{t14}</div>;
    $[27] = handlePrev;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="swiper-pagination swiper-pagination-fraction swiper-pagination-horizontal" />;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const t17 = Number(swiperActive) + 1;
  let t18;
  if ($[30] !== sliderArr.length || $[31] !== t17) {
    t18 = <div className={style.nav__counter}>{t17}/{sliderArr.length}</div>;
    $[30] = sliderArr.length;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = cn("swiper-button-next gallery_swiper__next", style.next);
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1236 6.49105C14.3948 6.21985 14.3948 5.78015 14.1236 5.50895L9.70422 1.08954C9.43302 0.81834 8.99332 0.81834 8.72212 1.08954C8.45093 1.36073 8.45093 1.80043 8.72212 2.07163L12.6505 6L8.72212 9.92837C8.45093 10.1996 8.45093 10.6393 8.72212 10.9105C8.99332 11.1817 9.43302 11.1817 9.70422 10.9105L14.1236 6.49105ZM0.055664 6.69444L13.6326 6.69445L13.6326 5.30556L0.0556641 5.30556L0.055664 6.69444Z" fill="#1C1C1C" /></svg>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== handleNext) {
    t21 = <div className={t19} onClick={handleNext} role="button" tabIndex="0">{t20}</div>;
    $[35] = handleNext;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t15 || $[38] !== t18 || $[39] !== t21) {
    t22 = <div className={style.nav}>{t15}{t16}{t18}{t21}</div>;
    $[37] = t15;
    $[38] = t18;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== swiperActive || $[42] !== t11 || $[43] !== t12 || $[44] !== t22 || $[45] !== t7 || $[46] !== t8) {
    t23 = <Swiper onSwiper={t7} slidesPerView={1} allowTouchMove={true} initialSlide={swiperActive} className={t8}>{t11}{t12}{t22}</Swiper>;
    $[41] = swiperActive;
    $[42] = t11;
    $[43] = t12;
    $[44] = t22;
    $[45] = t7;
    $[46] = t8;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t23 || $[49] !== t6) {
    t24 = <Portal><div className={t6}>{t23}</div></Portal>;
    $[48] = t23;
    $[49] = t6;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  return t24;
};
export default GallerySliderModalMobile;
function _temp(url) {
  return <SwiperSlide key={url}><GallerySlideModalInnerMobile url={url} /></SwiperSlide>;
}